import { cx } from './cx';
import type { ShopProductForm } from '@pc/db';

const LABEL: Record<ShopProductForm, string> = {
  raw_powder: 'Raw powder',
  vial_lyophilized: 'Vial (lyophilized)',
  vial_solution: 'Vial (solution)',
  capsule: 'Capsule',
  tablet: 'Tablet',
  troche: 'Troche',
  patch: 'Patch',
  nasal_spray: 'Nasal spray',
  oral_solution: 'Oral solution',
  cream_gel: 'Cream / gel',
  injection_kit: 'Injection kit',
  accessory: 'Accessory',
  other: 'Other',
};

const ICON: Record<ShopProductForm, string> = {
  raw_powder: '\u{1F9C2}',
  vial_lyophilized: '\u{1F9EA}',
  vial_solution: '\u{1F4A7}',
  capsule: '\u{1F48A}',
  tablet: '\u{1F48A}',
  troche: '\u{1F36C}',
  patch: '\u{1FA79}',
  nasal_spray: '\u{1F4A8}',
  oral_solution: '\u{1F95B}',
  cream_gel: '\u{1F9F4}',
  injection_kit: '\u{1F489}',
  accessory: '\u{1F9F0}',
  other: '\u{1F4E6}',
};

export const PRODUCT_FORMS: ReadonlyArray<{
  value: ShopProductForm;
  label: string;
  icon: string;
}> = (Object.entries(LABEL) as Array<[ShopProductForm, string]>).map(
  ([value, label]) => ({ value, label, icon: ICON[value] }),
);

export function productFormLabel(form: ShopProductForm | null | undefined): string {
  if (!form) return 'Unspecified';
  return LABEL[form];
}

export interface ProductFormPillProps {
  form: ShopProductForm | null | undefined;
  className?: string;
  /** Compact mode shows the icon only. */
  iconOnly?: boolean;
}

export function ProductFormPill({ form, className, iconOnly = false }: ProductFormPillProps) {
  if (!form) return null;
  return (
    <span
      className={cx(
        'inline-flex items-center gap-1 px-2 py-0.5 text-[11px] tracking-wide uppercase',
        'bg-paper-3 text-ink/80 border border-rule',
        className,
      )}
      title={LABEL[form]}
    >
      <span aria-hidden>{ICON[form]}</span>
      {iconOnly ? null : <span>{LABEL[form]}</span>}
    </span>
  );
}
